import { render } from "./sent.vue?vue&type=template&id=5879b176&lang=pug"
import script from "./sent.vue?vue&type=script&lang=js"
export * from "./sent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__